import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { StowageRuleId } from 'src/enums/stowage/stowageRule/stowageRuleId';
import { StowageRuleBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRuleBM';

/** Evaluated directly by StowagePlanRulesManager, as it applies to tanks regardless of cargo content. */
export const blockedTankMissingCallSoftRule: StowageRuleBM = {
    id: StowageRuleId.BlockedTankMissingCallSoftRule,
    name: 'A blocked tank should not reference a call that no longer exists in the rotation. Unblock the tank and block it again.',
    lastUpdatedUtc: '2026-10-01T00:00:00.000',
    condition: {},
    consequence: {
        type: StowageRuleConsequenceType.SoftRule,
        parameter: 'Blocked tank references a deleted call',
    },
};
